import {app} from "./firebaseConfig";
import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router} from 'react-router-dom'
import {getAuth, onAuthStateChanged, onIdTokenChanged, signOut} from "firebase/auth";
import {addErrorMessage, removeError, resetErrors, selectErrors} from "./core/errors/errorSlice";
import {authAction, resetUser, selectAuth, selectPharmacies, selectUser, setAuth, setUser} from "./core/reducer/auth/authSlice";
import {useAppDispatch, useAppSelector} from "./app/hooks";
import httpData from "./shared/utils/httpData";
import {selectActiveLoad} from "./core/loadSlice";
import ToastListError from "./shared/ui/toast/errors/toast/toastListError/ToastListError";
import LoaderFullScreen from "./shared/ui/loader/loaderFullscreen/LoaderFullScreen";
import http from "./shared/utils/http";
import PublicRoute from "./core/routes/PublicRoute";
import AuthRoute from "./core/routes/AuthRoute";
import {useSelector} from "react-redux";
import Header from "./core/layout/Header";
import Footer from "./core/layout/Footer";
import {setI18n} from "./shared/utils/languages/config/i18n";
import {logoutAction} from "./features/login/loginSlice";


function App() {
    const auth = getAuth(app);
    const authSelect = useAppSelector(selectAuth)
    const user = useAppSelector(selectUser)
    const [initLanguage, setInitLanguage] = useState<boolean>(false)

    const dispatch = useAppDispatch();
    // const [auth, setAuth] = useState<boolean | undefined>();
    // const [user, setUser] = useState<UserModel>();
    const logoutHandler = () => {
        signOut(auth).then(res => {
            dispatch(logoutAction())
        })
    }

    useEffect(() => {
        setI18n('it', () => setInitLanguage(true));
        !localStorage.getItem('token') && dispatch(setAuth(false))
        onIdTokenChanged(auth, (user) => {
            if (user) {
                user.getIdToken().then((token) => {
                    console.log("Nuovo token ricevuto:", token);
                    localStorage.setItem('token', token)
                });
            }
        });
        onAuthStateChanged(auth, (user: any) => {
            if (user) {
                localStorage.setItem('token', user.accessToken)
                http.get('user').then(res => {
                    dispatch(authAction(res))
                })
            } else {
                dispatch(resetUser())
                dispatch(setAuth(false))
            }
        })

        return () => {
            dispatch(resetErrors());
        }
    }, [])


    const listErrors = useSelector(selectErrors);
    const showLoader = useSelector(selectActiveLoad)

    return (
        <Router>
            {authSelect && <Header logoutHandler={logoutHandler}/>}
            <ToastListError list={listErrors} closeAction={(id) => dispatch(removeError(id))}/>
            <LoaderFullScreen show={showLoader}/>

            <div style={{marginTop: '90px'}} className={'h-100 overflow-auto'}>
                {
                    (authSelect === undefined || !initLanguage) ?
                        <LoaderFullScreen show={true}/>
                        :
                        <>
                            {authSelect ?
                                <AuthRoute logout={logoutHandler} user={user}/> :
                                <PublicRoute/>}
                        </>
                }
            </div>
            {authSelect && <Footer/>}


        </Router>
    );
}

export default App;
